module.exports = __webpack_public_path__ + "static/media/company_elephant_enterprises.0b471788.svg";